// eslint-disable-next-line import/no-cycle
import api from '@/services/api';

export default {
  async fetchFechamento({ dispatch, commit }, payload) {
    const { codigoProcesso, codigoFilial } = payload;
    dispatch('toggleLoading', true, { root: true });
    try {
      const response = await api.get(`/processo/fechamento/${codigoProcesso}/filial/${codigoFilial}`);
      commit('UPDATE_FECHAMENTO', response.data);
    } catch (err) {
      dispatch(
        'setGlobalError',
        'Não foi possível recuperar as informações do fechamento',
        { root: true },
      );
    }
    dispatch('toggleLoading', false, { root: true });
  },
};
